import { saga as authSaga } from '@tgtg/core/auth';
import { saga as sessionSaga } from '@tgtg/core/session';

import { sagaMiddleware } from './middlewares';

export const runSagas = () => {
  sagaMiddleware.run(authSaga);
  sagaMiddleware.run(sessionSaga);
};
